import Axios from "axios";

const sendCodeToEmail = async (email: string, code: string) => {
  try {
    const res = await Axios.post(
      "https://us-central1-iadr-4224d.cloudfunctions.net/sendMail",
      {
        from: "seaade.iadr.2020@gmail.com <SEAADE-IADR-SEA-2020 Support Team>",
        replyTo:
          "seaade.iadr.2020@gmail.com <SEAADE-IADR-SEA-2020 Support Team>",
        to: email,
        subject: "Your Ticket Code for IADR-SEA-2020",
        text: `Dear participants,\n\nPlease see below your ticket code for event access. Kindly use this email and the code to log in at http://seaade-iadr-sea-2020.com\n\nEmail: ${email}\nCode:${code}\n\nRegards,\nSEAADE-IADR-SEA-2020 Support Team.`,
      }
    );

    return res;
  } catch (error) {
    throw error;
  }
};

export default sendCodeToEmail;
